import { Component, Input, OnInit } from '@angular/core';
import { RecentForumPost } from 'src/app/models/forum/recent-forum-post';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-recent-forum-posts',
  templateUrl: './recent-forum-posts.component.html',
  styleUrls: ['./recent-forum-posts.component.scss']
})
export class RecentForumPostsComponent implements OnInit {

  @Input() count: number = 10;

  public posts: Array<RecentForumPost>;
  constructor(private dataService: DataService) { }
  imageLoadFailed = false;


  ngOnInit(): void {
    this.dataService.getRecentForumPosts(this.count).subscribe(resp => {

      //this.posts = (resp as any[]).map(post => ({
      //  ...post,
      //  avatarSrc: this.getAvatarUrl(post.avatarUrl),
      //  imageFailed: false
      //}));

      this.posts = resp.map((post: any) => {
        const p = new RecentForumPost(post);
        p.avatarSrc = this.getAvatarUrl(p.avatarUrl || '');
        p.imageFailed = false;
        return p;
      });


    });
  }


  goToForum(slug: string): void {
    window.open(`https://forum.promaster.com/Forum/chat/${slug}`, '_blank');
  }




  getAvatarUrl(path: string | null | undefined): string {
    if (!path || path.trim().toLowerCase() === 'null' || path.trim().toLowerCase() === 'undefined') {
      console.warn('Invalid avatar URL:', path);
      return 'assets/images/Avatar.png';
    }

    path = path.trim();

    if (path.startsWith('https://members.promaster.com')) {
      return path.replace('https://members.promaster.com', 'https://forum.promaster.com');
    }

    if (path.startsWith('https://forum.promaster.com')) {
      return path;
    }

    if (path.startsWith('/content/uploads')) {
      return `https://forum.promaster.com${path}`;
    }

    return `https://forum.promaster.com/content/uploads/${path}`;
  }



  onImageError(post: any): void {
    if (!post.imageFailed) {
      post.avatarSrc = 'assets/images/Avatar.png';
      post.imageFailed = true;
    }
  }



  openForum(slug: string) {
    window.open(`https://forum.promaster.com/Forum/chat/${slug}`, '_blank', 'noopener,noreferrer');
  }



}
